import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const generateImgixUrl = (url) => {
  if (url !== '') {
    const res = url.replace('https://front.travpromobile.com/', 'https://imgtravpromobile.imgix.net/');
    const returnValue = `${res}?fit=clip&w=200&h=auto`;
    return returnValue;
  }
};


const ContactViewCard = ({
  isGroupedContact, name, description, telephone, town, mail, imageUrl, region
}) => (
  <div className={`contactView ${isGroupedContact ? 'grouped' : ''}`}>
    <div className="contactView__Content">
      { generateImgixUrl(imageUrl) && (
        <img className="headshot" src={generateImgixUrl(imageUrl)} alt={`${name} - ${description}`} />
      ) }
      <h1>{name}</h1>
      <h2 dangerouslySetInnerHTML={{__html: description}} />
      {town && <p><strong>{town}</strong></p>}
      {region && <p><strong>{region}</strong></p>}
      {telephone && (
        <a href={`tel:${telephone.trim()}`}>
          <FontAwesomeIcon icon={['fas', 'phone']} />+{telephone}
        </a>
      )}
      <a href={`mailto:${mail}`}>
        <FontAwesomeIcon icon={['fas', 'envelope']} />
        {mail}
      </a>
    </div>
  </div>
);

export default ContactViewCard;
